import React, { Suspense, lazy } from 'react'
const StoreBookDetail = lazy(() =>
  import('@!/Store/BookDetail/containers/StoreBookDetail').then((module) => ({ default: module.default || module.StoreBookDetail })),
)
import StoreApp from '@!/Store/Common/containers/StoreApp'
import { AppProvider } from '@!/providers'

const StoreBookDetailApp = (props) => {
  return (
    <AppProvider>
      <StoreApp {...props}>
        <Suspense fallback={null}>
          <StoreBookDetail book={props.bookDetail} currentTime={props.currentTime} />
        </Suspense>
      </StoreApp>
    </AppProvider>
  )
}

export default StoreBookDetailApp
